import React, { Component } from 'react';
import { Navbar, Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import './App.css';
import MortgageCalculator from './calculators/MortgageCalculator';
import EmergencySavingsCalculator from './calculators/EmergencySavingsCalculator';
import HomeBuyingSavingsCalculator from './calculators/HomeBuyingSavingsCalculator';
import RetirementNestEggCalculator from './calculators/RetirementNestEggCalculator';
import LongTermCareCostsCalculator from './calculators/LongTermCareCostsCalculator';
import AffordHomeBudgetCalculator from './calculators/AffordHomeBudgetCalculator';
import SavingsGoalCalculator from './calculators/SavingsGoalCalculator';
import BuyACarCalculator from "./calculators/BuyACarCalculator";
import HomeRefinanceCalculator from "./calculators/HomeRefinanceCalculator";

const Anchor = (props) => <span className="anchor" {...props} />

class App extends Component {
  render() {
    const returnToTop = <a href="#top" className="return-to-top">Back to top</a>
    return (
      <div className="App">
        <Anchor id="top" />
        <Navbar fixedTop>
          <Navbar.Header>
            <Navbar.Brand>
              <a href="#top">Think Glink Money Calculators</a>
            </Navbar.Brand>
          </Navbar.Header>
          <Nav>
            <NavDropdown eventKey={1} title="Calculators" id="basic-nav-dropdown">
              <MenuItem eventKey={1.1} href="#mortgage">Mortgage</MenuItem>
              <MenuItem eventKey={1.2} href="#emergency-savings">Emergency Savings</MenuItem>
              <MenuItem eventKey={1.3} href="#home-buying-savings">Home Buying Savings</MenuItem>
              <MenuItem eventKey={1.4} href="#retirement-nest-egg">Retirement Nest Egg</MenuItem>
              <MenuItem eventKey={1.4} href="#long-term-care-costs">Long Term Care Costs</MenuItem>
              <MenuItem eventKey={1.5} href="#afford-home">Afford Home</MenuItem>
              <MenuItem eventKey={1.6} href="#savings-goal">Savings Goal</MenuItem>
              <MenuItem eventKey={1.7} href="#buy-a-car">Buy a Car</MenuItem>
              <MenuItem eventKey={1.8} href="#home-refinancing">Refinancing Home</MenuItem>
            </NavDropdown>
          </Nav>
        </Navbar>
        <Anchor id="mortgage" />
        <MortgageCalculator />
        {returnToTop}

        <Anchor id="emergency-savings" />
        <EmergencySavingsCalculator />
        {returnToTop}

        <Anchor id="home-buying-savings" />
        <HomeBuyingSavingsCalculator />
        {returnToTop}

        <Anchor id="retirement-nest-egg" />
        <RetirementNestEggCalculator />
        {returnToTop}

        <Anchor id="long-term-care-costs" />
        <LongTermCareCostsCalculator />
        {returnToTop}

        <Anchor id="afford-home" />
        <AffordHomeBudgetCalculator />
        {returnToTop}

        <Anchor id="savings-goal" />
        <SavingsGoalCalculator />
        {returnToTop}

        <Anchor id="buy-a-car" />
        <BuyACarCalculator />
        {returnToTop}

        <Anchor id="home-refinancing" />
        <HomeRefinanceCalculator />
        {returnToTop}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js